export const DIALOG_PRIORITIES = {
  AGREEMENT: 100,
  APP_UPDATE: 90,
  CALCULATOR_BLOCK: 70,
  CONFIRM: 60,
  AUTH_ONBOARDING: 50,
  PAYMENT_REMINDER: 30,
  BANNERS: 10,
}
